module.exports = __webpack_public_path__ + "static/media/table_background_med.d989d6ca.jpg";